import { randomIntegerBetween } from 'lib/maths/mathUtils'

/**
 *
 * @TODO replace when svc is ready
 */
export function mockPointsAndCreditsEarned() {
  const statusCreditsEarned = randomIntegerBetween(100, 500)

  return {
    orderPointsEarned: statusCreditsEarned * 10,
    statusCreditsEarned,
  }
}

export function getNextTierConfig(
  accountTier: App.LuxLoyaltyTier,
  tierConfig: App.LuxLoyaltyProgramConfigDetails,
) {
  const currentTierConfigSortingOrder = tierConfig.tiers[accountTier].sortingOrder
  const tiers = Object.values(tierConfig.tiers)

  return tiers.find(tier => tier.sortingOrder === currentTierConfigSortingOrder + 1)
}
